import React from "react";
import { Checkbox, Radio } from "antd";

function QuestionBox({
  questionNumber,
  questionTitle,
  inputType = "checkbox", // "checkbox" | "radio"
  options = [],
  showTextarea = false,
  textareaPlaceholder = "Write your answer here",
}) {
  return (
    <div className="bg-[#7C63A40D] question rounded-[20px] p-5">
      <p className="text-[#2F2F2FCC] text-[12px]">Question {questionNumber}</p>
      <h3 className="text-[#2F2F2F] font-semibold">{questionTitle}</h3>

      <div className="grid gap-2 mt-2">
        {inputType === "multiple" &&
          options.map((option, idx) => (
            <Checkbox
              key={option.value || idx}
              value={option.value}
              className="text-[#2F2F2FCC] border-[#2F2F2FCC] w-fit"
            >
              {option.label}
            </Checkbox>
          ))}
        {console.log(
          "sdfasdfasdfasdfasdfasdfsdfsdf dsfsdfdsdfgdsfgdsf",
          options
        )}
        {inputType === "single" && (
          <Radio.Group className="!grid">
            {options.map((option, idx) => (
              <Radio
                key={idx}
                value={option?.value}
                className="text-[#2F2F2FCC] border-[#2F2F2FCC]"
              >
                {option?.label}
              </Radio>
            ))}
          </Radio.Group>
        )}
        {inputType === "normal" && (
          <textarea
            className="border-[#7C63A41A] border-[1px] rounded-[10px] resize-none placeholder:text-[#2F2F2F66] p-3 h-[121px]"
            placeholder={"Write your answer here"}
          />
        )}
      </div>
    </div>
  );
}

export default QuestionBox;
